import { ErrorBanner } from 'ui/banner';

type Props = {
  id?: number;
  idType?: string;
  message?: string;
  project?: {
    name: string;
    id: number;
  };
};
export const DEFAULT_PROJECT_STRING = 'this project';

export const InvalidIdMessage = ({ project, idType, id, message }: Props) => {
  const projectString = project
    ? `Project: ${project.id} - ${project.name}`
    : DEFAULT_PROJECT_STRING;

  return (
    <ErrorBanner data-test="invalidIdMessage">
      {message || `Invalid or unauthorized ${idType}: ${id} for ${projectString}`}
    </ErrorBanner>
  );
};
